import { useQuery } from '@tanstack/react-query';

import { useXFetch } from '~/shared/utils/useXFetch';
import { LastDayResponse, SavingStatsResponse } from '~/shared/types/api';
import Card from '~/shared/components/Card';
import { DEFAULT_REFETCH_INTERVAL_MS } from '~/shared/constants/polling';

import AverageUtilizationCard from './AverageUtilizationCard';
import MonthlySavingsCard from './MonthlySavingCard';

export default function KPICards({
  queryUrl,
  // utilizationQueryUrl,
}: {
  queryUrl: string;
  utilizationQueryUrl: string;
}) {
  const api = useXFetch();
  const {
    data: savingStatsData,
    isLoading: isLoadingSavingStats,
    error: errorSavingStats,
  } = useQuery({
    queryKey: [queryUrl],
    queryFn: () => api<SavingStatsResponse>(queryUrl),
    refetchOnWindowFocus: false,
    refetchInterval: (query) => (query.state.data ? DEFAULT_REFETCH_INTERVAL_MS : false),
  });

  const { data, isLoading: isLoadingAvgUtilization } = useQuery({
    queryKey: ['getLastDay'],
    queryFn: () => api<LastDayResponse>('/api/v1/opt-log/last-day'),
    refetchOnWindowFocus: false,
    refetchInterval: (query) => (query.state.data ? DEFAULT_REFETCH_INTERVAL_MS : false),
  });

  const { lastDay } = data || {};

  const { currentEstimatedMonthlySavings, PotentialEstimatedMonthlySaving } = savingStatsData || {};

  if (errorSavingStats || (!savingStatsData && !isLoadingSavingStats)) {
    return <EmptyState />;
  }

  const avgUtilNum = lastDay?.avgUtilization;
  const avgUtilStr = typeof avgUtilNum === 'number' ? `${avgUtilNum.toFixed(0)} %` : 'N/A';

  return (
    <div className="flex px-[30px] gap-[10px]">
      <AverageUtilizationCard size={avgUtilStr} loading={isLoadingAvgUtilization} />
      <MonthlySavingsCard
        savings={`$${(currentEstimatedMonthlySavings ?? 0).toFixed(2)}`}
        potential={`$${(PotentialEstimatedMonthlySaving ?? 0).toFixed(2)} full potential`}
        percentage={
          PotentialEstimatedMonthlySaving && currentEstimatedMonthlySavings
            ? Math.round((currentEstimatedMonthlySavings / PotentialEstimatedMonthlySaving) * 100)
            : 0
        }
        loading={isLoadingSavingStats}
      />
    </div>
  );
}

function EmptyState() {
  return (
    <div className="px-[30px] ">
      <Card className="w-full h-[150px]  flex justify-center items-center text-[12px] ">
        No Results
      </Card>
    </div>
  );
}
